import PropTypes from 'prop-types';
import styled from 'styled-components';
import PortalIdParser from 'PortalIdParser';
import UIFlex from 'UIComponents/layout/UIFlex';
import { propTypeForSizes, toShorthandSize } from 'UIComponents/utils/propTypes/tshirtSize';
import OnboardingTourButton from './OnboardingTourButton';
import { BACK, FINISH, NEXT } from '../constants/TourActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonsWrapper = styled.div.withConfig({
  displayName: "OnboardingTourButtons__ButtonsWrapper",
  componentId: "bkb968-0"
})(["margin-bottom:-8px;margin-right:-8px;"]);
export default function OnboardingTourButtons({
  beforeBackClickHandler,
  buttons,
  buttonSize,
  completeActionKey,
  enableBackButton
}) {
  return /*#__PURE__*/_jsx(ButtonsWrapper, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      wrap: "wrap",
      children: [enableBackButton && /*#__PURE__*/_jsx(OnboardingTourButton, {
        action: BACK,
        beforeBack: beforeBackClickHandler,
        className: "m-left-0 m-bottom-2 p-left-3",
        size: toShorthandSize(buttonSize),
        use: "tertiary-light"
      }), buttons.map((button, index) => {
        const {
          action,
          beforeButtonEnabled,
          disableTaskCompletionModal,
          text,
          url,
          navigationCallbackPath
        } = button;
        const buttonProps = {
          className: 'm-left-0 m-bottom-2 m-right-2',
          href: url && url.replace('%portalId%', String(PortalIdParser.get())),
          size: toShorthandSize(buttonSize),
          use: !index ? 'primary' : undefined
        };
        if (action === NEXT) {
          return /*#__PURE__*/_jsx(OnboardingTourButton, Object.assign({
            action: NEXT,
            beforeButtonEnabled: beforeButtonEnabled,
            "data-test-id": `${NEXT}-onboarding-step-button`,
            navigationCallbackPath: navigationCallbackPath
          }, buttonProps, {
            children: text
          }), index);
        }
        if (action === FINISH) {
          const shouldOpenTaskCompletionModal = completeActionKey && !url && !disableTaskCompletionModal;
          return /*#__PURE__*/_jsx(OnboardingTourButton, Object.assign({
            action: FINISH,
            beforeButtonEnabled: beforeButtonEnabled,
            "data-test-id": `${FINISH}-onboarding-step-button`,
            taskKey: shouldOpenTaskCompletionModal ? completeActionKey : undefined
          }, buttonProps, {
            children: text
          }), index);
        }
        return /*#__PURE__*/_jsx(OnboardingTourButton, Object.assign({
          beforeButtonEnabled: beforeButtonEnabled,
          "data-test-id": "onboarding-step-button"
        }, buttonProps, {
          children: text
        }), index);
      })]
    })
  });
}
OnboardingTourButtons.defaultProps = {
  buttonSize: 'md'
};
OnboardingTourButtons.propTypes = {
  beforeBackClickHandler: PropTypes.func,
  buttonSize: propTypeForSizes(['sm', 'md'], ['default']),
  buttons: PropTypes.arrayOf(PropTypes.object).isRequired,
  completeActionKey: PropTypes.string,
  enableBackButton: PropTypes.bool
};